import { render } from "./GNULicence.vue?vue&type=template&id=61b225bd"
import script from "./GNULicence.vue?vue&type=script&lang=js"
export * from "./GNULicence.vue?vue&type=script&lang=js"

import exportComponent from "C:\\xampp\\htdocs\\orangehrm-5.8\\installer\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__